import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";

const ACCESS_TOKEN_KEY = "access_token";
const SMC_USER_KEY = "smc_profile_user";

export async function getAccessToken() {
	const token = firebase.auth().currentUser.getIdToken();

	return await token;
}

export function setLoggedInDetails(smcUser) {
	localStorage.setItem(SMC_USER_KEY, JSON.stringify(smcUser));
}

export function getLoggedInDetails() {
	let smcUser;

	smcUser = localStorge.getItem(SMC_USER_KEY);

	if (!smcUser || smcUser === null || smcUser === undefined) {
		return null;
	}

	const parsedUser = JSON.parse(smcUser);
	return parsedUser;
}

export function evaluateError(data) {
	if (data.Data && data.Success !== true) {
		return false;
	}

	return true;
}

export function processFailure(xhr, func) {
	if (!xhr.response || xhr.response.status === 200) {
		func({});
		return;
	}
	if (xhr.response.status === 401) {
		func({
			OperationSuccessful: false,
			Data: { FriendlyResponse: "Unauthorized" },
		});
	} else if (xhr.response.status === 500) {
		const res = xhr.response.data;
		if (res.FriendlyResponse === "Multiple logins detected") {
			console.log("multipleLogins");
		} else if (res.FriendlyResponse === "Support Session Expired") {
			logout();
			func({
				OperationSuccessful: false,
				Data: { FriendlyResponse: response.FriendlyResponse },
			});
		} else {
			func({
				OperationSuccessful: false,
				Data: { FriendlyResponse: "UNHANDLED ERROR" },
			});
		}
	} else {
		func({
			OperationSuccessful: false,
			Data: { FriendlyResponse: "UNHANDLED ERROR" },
		});
	}
}
